import React from "react";
import { Sparkles, Instagram, Mail } from "lucide-react";
import { LEGAL_LINKS } from "../constants/links";

export default function Footer() {
    return (
        <footer className="bg-alma-night text-alma-white/80">
            <div className="max-w-[1400px] mx-auto px-6 sm:px-8 lg:px-14 py-16">
                <div className="grid md:grid-cols-3 gap-10 mb-14">
                    <div>
                        <a href="#top" className="inline-flex items-center gap-2.5">
                            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-alma-gold to-alma-goldDeep text-alma-white">
                                <Sparkles className="h-4 w-4" strokeWidth={1.4} />
                            </span>
                            <span className="font-serif text-xl text-alma-white">
                                Alquimia <span className="italic text-alma-goldSoft">del Alma</span>
                            </span>
                        </a>
                        <p className="mt-5 text-sm leading-relaxed max-w-sm text-alma-white/60">
                            Tu hogar espiritual. Una comunidad cercana donde vivir tu espiritualidad de forma
                            práctica, terrenal y consciente, de la mano de Lidia González y Santi.
                        </p>
                    </div>

                    <div>
                        <div className="text-[10px] tracking-[0.3em] uppercase text-alma-white/40 mb-4">Navegación</div>
                        <ul className="space-y-2.5 text-sm">
                            <li><a href="#esencia" className="hover:text-alma-goldSoft transition-colors">La comunidad</a></li>
                            <li><a href="#espacios" className="hover:text-alma-goldSoft transition-colors">Espacios</a></li>
                            <li><a href="#acompanamiento" className="hover:text-alma-goldSoft transition-colors">Quién te acompaña</a></li>
                            <li><a href="#precios" className="hover:text-alma-goldSoft transition-colors">Acceso</a></li>
                        </ul>
                    </div>

                    <div>
                        <div className="text-[10px] tracking-[0.3em] uppercase text-alma-white/40 mb-4">Contacto</div>
                        <ul className="space-y-3 text-sm">
                            <li className="flex items-center gap-2">
                                <Mail className="h-4 w-4 text-alma-goldSoft" />
                                hola@somosalquimiadelalma.com
                            </li>
                            <li className="pt-2">
                                <a
                                    href="#"
                                    className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-alma-white/15 hover:bg-alma-white/10 transition-colors"
                                    aria-label="Instagram"
                                >
                                    <Instagram className="h-4 w-4" strokeWidth={1.5} />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-alma-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-alma-white/40">
                        © {new Date().getFullYear()} Alquimia del Alma. Todos los derechos reservados.
                    </p>
                    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-alma-white/50">
                        <a href={LEGAL_LINKS.privacy} className="hover:text-alma-white">Política de privacidad</a>
                        <a href={LEGAL_LINKS.legal} className="hover:text-alma-white">Aviso legal</a>
                        <a href={LEGAL_LINKS.cookies} className="hover:text-alma-white">Política de cookies</a>
                        <a href={LEGAL_LINKS.terms} className="hover:text-alma-white">Condiciones de contratación</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
